import { AiOutlineFileSync } from "react-icons/ai";
import SyncProduct from './syncProduct'

function SyncMaster() {

  return (
    <>
      <div>
        <ul
          className="flex flex-col flex-wrap justify-center pl-0 mt-2 mb-1 list-none border-b-0 md:flex-row"
          role="tablist"
          data-te-nav-ref>
          <li role="presentation">
            <a
              href="#tabs-sync-product"
              className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-rose data-[te-nav-active]:text-rose dark:text-neutral-400 dark:hover:bg-transparent data-[te-nav-active]:border-rose-400 data-[te-nav-active]:text-rose-400"
              data-te-toggle="pill"
              data-te-target="#tabs-sync-product"
              data-te-nav-active
              role="tab"
              aria-controls="tabs-sync-product"
              aria-selected="true"
              >
                <div className='flex items-center gap-2'>
                  <AiOutlineFileSync size={20}/><span className=''>Sync Product</span>
                </div>
            </a>
          </li>
        </ul>
        <div className="mb-1">
          <div
            className="hidden opacity-0 opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-sync-product"
            role="tabpanel"
            aria-labelledby="tabs-sync-product-tab"
            data-te-tab-active>
              <SyncProduct />
          </div>
        </div>
      </div>
    </>
  );
}

export default SyncMaster;
